import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Container,
    createTheme,
    CssBaseline,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Slide,
    Stack,
    Switch,
    TextField,
    ThemeProvider,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SendIcon from "@mui/icons-material/Send";
import React, { useEffect, useState } from "react";
import { Edad } from "../modules/ui/Edad";
import { Sexo } from "../modules/ui/Sexo";
import TallaCamiseta from "../modules/ui/TallaCamiseta";
import { Telefono } from "../modules/ui/Telefono";
import Swal from "sweetalert2";
import { TextareaCustom } from "../modules/ui/TextareaCustom";
import { DatosFactura } from "../modules/ui/DatosFactura";
import { getRefBancaria } from "../../helpers/getRefBancaria";
import validator from 'validator';
import { SelectCustom } from "../modules/ui/SelectCustom";
import { sendEmail } from "../../services/sendEmail";
import { setEmailBodyExpociencias } from "../../helpers/setEmailBodyExpociencias";
import { renderToString } from 'react-dom/server';
import { createResumeExpociencias22 } from "../../services/createResumeExpociencias22";
import { saveDataExpociencias22 } from "../../services/saveDataExpociencias22";
import moment from 'moment';
import { CustomDialog } from "../modules/dialogs/CustomDialog";


export const Expociencias = () => {

    // Clave de proyecto de recursos propios proporcionado por Finanzas
    const PROY_RECURSOS = '20451';

    const [formValues, setFormValues] = useState({
        asesorNombres: "",
        asesorApellidos: "",
        asesorCorreo: "",
        asesorTelefono: "",
        asesorTallaCamiseta: "",
        instNombre: "",
        instDomicilio: "",
        instMunicipio: "",
        proyTitulo: "",
        proyCategoria: "",
        proyArea: "",
        proyResumen: "",
        participacion: "",
        est1NombreCompleto: "",
        est1Correo: "",
        est1Telefono: "",
        est1Edad: "",
        est1Sexo: "",
        est1TallaCamiseta: "",
        est2NombreCompleto: "",
        est2Correo: "",
        est2Telefono: "",
        est2Edad: "",
        est2Sexo: "",
        est2TallaCamiseta: "",
        est3NombreCompleto: "",
        est3Correo: "",
        est3Telefono: "",
        est3Edad: "",
        est3Sexo: "",
        est3TallaCamiseta: "",
        requiereFactura: false,
        factNombre: "",
        factRfc: "",
        factCP: "",
        factUsoCFDI: "",
        factRegimenFiscal: "",
        comentarios: "",
        refBancaria: "",
        compPago: "",
        compPagoEst: "",
        claveProyRec: PROY_RECURSOS,
        fechaRegistro: "",
        fechaPago: "",
        fechaPagoEst: "",
    });

    const [sendingForm, setSendingForm] = useState(false);

    // Confirm Dialog
    const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
    const handleCloseConfirmDialog = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpenConfirmDialog(false);
        }
    };

    const isDataProcessed = async() => {

        // PROCESAR INFO
        // - guardar en db
        const saveResult = await saveDataExpociencias22(formValues);
        // console.log(saveResult);
        if (saveResult.exito === 0) {
            return false;
        }

        // - crear pdf
        const fileName = `${refBancaria}_resumen.pdf`;
        const pdfResult = await createResumeExpociencias22({
            title: proyTitulo,
            fileName: fileName, 
            category: proyCategoria, 
            area: proyArea,
            content: proyResumen
        });
        // console.log(pdfResult);
        if (pdfResult.exito === 0) {
            return false;
        }

        // - enviar correo
        const urlResumen = `https://eventos.cibnor.mx/registro/apiServiciosSIARF/${pdfResult.data}`;
        const urlConfirma = `${process.env.REACT_APP_HOMEPAGE}/expociencias/subir-comprobante/${saveResult.data}`;
        const msgbody = renderToString( setEmailBodyExpociencias(formValues, urlConfirma, urlResumen) );
        const emailResult = await sendEmail({
            "toemail": asesorCorreo,
            "subject": "[Expociencias 2022] Registro en línea",
            "message": msgbody,
            "replyto": "expociencias@cibnor.mx",
            "tocc": process.env.REACT_APP_TOCC_EXPOCIENCIAS22,
        });
        console.log(emailResult);
        // EOF: PROFESAR INFO
        if (emailResult.exito === 0) {
            return false;
        }

        return true;
    }

    // El formulario ya fue validado y el usuario dijo que SI al dialogo de confirmacion
    const handleConfirmDialogButtonYes = async() => {
        setOpenConfirmDialog(false);
        
        // Se muestra el dialog de "Por favor, espera..."
        setSendingForm(true);

        // Procesa la info
        const AllOk = await isDataProcessed();
        setSendingForm(false);
        if ( AllOk ) {

            Swal.fire({
                title: "Sus datos han sido recibidos exitosamente.",
                text: 'Consulte su correo electrónico para más información.',
                icon: 'success',
                confirmButtonText: 'Ir al sitio web del evento',
                allowEscapeKey: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/eventos-cibnor/3180-expociencias-2022');
                }
            }); 

        } else {
            await sendEmail({
                "toemail": "eventos@cibnor.mx",
                "subject": "[Expociencias 2022] Error",
                "message": formValues,
            });

            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedío un error en el servidor...",
                text: 'Disculpe el inconveniente.',
                icon: 'error',
                confirmButtonText: 'Ir al sitio web del evento',
                footer: 'Ya se ha notificado al area correspondiente sobre su situación.'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/eventos-cibnor/3180-expociencias-2022');
                }
            }); 
        }
    }

    // Validar el formumario
    const isFormValid = () => {

        // Campos obligatorios para todos
        if ( [ asesorNombres, asesorApellidos, asesorCorreo, asesorTelefono, asesorTallaCamiseta, participacion, 
                instNombre, instDomicilio, instMunicipio, proyTitulo, proyCategoria, proyArea, proyResumen ].includes("") ) {
            Swal.fire("Elementos vacios.", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }
        
        // Campos obligatorios dependiendo el tipo de participacion
        switch (participacion) {
            case 'individual':
                if ( [ est1NombreCompleto, est1Correo, est1Telefono, est1Edad, est1Sexo, est1TallaCamiseta ].includes("") ) {
                    Swal.fire("Elementos vacios.", "Los datos del participante marcados con [ * ] son obligatorios.", "error");
                    return false;
                }   
                break;
        
            case 'equipo2':
                if ( [ est1NombreCompleto, est1Correo, est1Telefono, est1Edad, est1Sexo, est1TallaCamiseta,
                    est2NombreCompleto, est2Correo, est2Telefono, est2Edad, est2Sexo, est2TallaCamiseta ].includes("") ) {
                    Swal.fire("Elementos vacios.", "Los datos de los participantes marcados con [ * ] son obligatorios.", "error");
                    return false;
                }   
                break;

            case 'equipo3':
                if ( [ est1NombreCompleto, est1Correo, est1Telefono, est1Edad, est1Sexo, est1TallaCamiseta,
                    est2NombreCompleto, est2Correo, est2Telefono, est2Edad, est2Sexo, est2TallaCamiseta,
                    est3NombreCompleto, est3Correo, est3Telefono, est3Edad, est3Sexo, est3TallaCamiseta ].includes("") ) {
                    Swal.fire("Elementos vacios.", "Los datos de los participantes marcados con [ * ] son obligatorios.", "error");
                    return false;
                }   
                break;
        
            default:
                break;
        }

        // Campos obligatorios en caso de que requiera factura
        if (requiereFactura) {
            if ( [ factNombre, factRfc, factCP, factUsoCFDI, factRegimenFiscal ].includes("") ) {
            Swal.fire("Datos para facturar incompletos.", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
            }
        }

        // Longitud del resumen
        const wordCount = proyResumen.trim().split(" ").filter(function(n) { return n !== '' }).length;
        if (wordCount > 250) {
            Swal.fire("Longitud del resumen excedida.", `Ingresaste en total ${wordCount} palabras.`, "error");
            return false;
        }
        
        // Correo valido asesor
        if ( !validator.isEmail(asesorCorreo) ) {
            Swal.fire("Correo electrónico invalido.", `El formato [ ${asesorCorreo} ] es incorrecto.`, "error");
            return false;
        }

        // Correos validos estudiantes
       switch (participacion) {
        case 'individual':
            if ( !validator.isEmail(est1Correo) ) {
                Swal.fire("Correo electrónico invalido.", `Confirma que el correo del estudiante sea el correcto.`, "error");
                    return false;
            }   
            break;
        case 'equipo2':
            if ( !validator.isEmail(est1Correo) || !validator.isEmail(est2Correo) ) {
                Swal.fire("Correo electrónico invalido.", `Confirma que los correos de los estudiantes sean correctos.`, "error");
                return false;
            }   
            break;
        case 'equipo3':
            if ( !validator.isEmail(est1Correo) || !validator.isEmail(est2Correo) || !validator.isEmail(est3Correo) ) {
                Swal.fire("Correo electrónico invalido.", `Confirma que los correos de los estudiantes sean correctos.`, "error");
                return false;
            }   
            break;
        default:
            break;
       }

        return true;
    }

    // Waiting Dialog
    const handleCloseWaitingDialog = (_, reason) => {
        if (reason !== 'backdropClick') {
            setOpenConfirmDialog(false);
        }
    };

    const {
        asesorNombres,
        asesorApellidos,
        asesorCorreo,
        asesorTelefono,
        asesorTallaCamiseta,
        instNombre,
        instDomicilio,
        instMunicipio,
        proyTitulo,
        proyCategoria,
        proyArea,
        proyResumen,
        participacion,
        est1NombreCompleto,
        est1Correo,
        est1Telefono,
        est1Edad,
        est1Sexo,
        est1TallaCamiseta,
        est2NombreCompleto,
        est2Correo,
        est2Telefono,
        est2Edad,
        est2Sexo,
        est2TallaCamiseta,
        est3NombreCompleto,
        est3Correo,
        est3Telefono,
        est3Edad,
        est3Sexo,
        est3TallaCamiseta,
        requiereFactura,
        factNombre,
        factRfc,
        factCP,
        factUsoCFDI,
        factRegimenFiscal,
        comentarios,
        refBancaria,
        compPago,
        compPagoEst,
        claveProyRec,
        fechaRegistro,
        fechaPago,
        fechaPagoEst,
    } = formValues;
    // Las variables deben estar desestructuradas para poder validar el state, 
    // independiente de si se incilizan en el state o en su propio módulo.


    // Para expander un panel o el otro
    const [expandedPanel, setExpandedPanel] = useState(false);
    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedPanel(isExpanded ? panel : false);
    };    

    // Cada que cambia el valor en cualquier control de formulario
    const handleInputChange = ({ target }) => {
        // console.log(target.name, target.value);
        setFormValues({
            ...formValues,
            [target.name]: target.value,
        });
    };

    // Para el swich de "Requiere Factura"
    const [checked, setChecked] = useState(false);
    const switchHandler = (event) => {
        setChecked(event.target.checked);

        setFormValues({
            ...formValues,
            [event.target.name]: event.target.checked,
        });
    };

    /* Enviar formulario */
    const handleSubmit = async (event) => {
        event.preventDefault();

        // // PRUEBAS
        // const resultTest = await isDataProcessed();
        // console.log(resultTest);
        // // EOF PRUEBAS

        // No paso la validacion, deten el procesamiento
        if ( !isFormValid() ) {
            return false;
        }
        console.log("Formulario valido, continuamos...");



        // Si el formulario es valido, se muestra el dialog de confirmacion de envio
        setOpenConfirmDialog(true);

        // Si el usuario dice que si en el ConfirmDialog, la ejecucion
        // continua en _handleConfirmDialogButtonYes_
        
        console.log( "formValues", 
            "[",
            asesorNombres,
            asesorApellidos,
            asesorCorreo,
            asesorTelefono,
            asesorTallaCamiseta,
            instNombre,
            instDomicilio,
            instMunicipio,
            proyTitulo,
            proyCategoria,
            proyArea,
            participacion,
            est1NombreCompleto,
            est1Correo,
            est1Telefono,
            est1Edad,
            est1Sexo,
            est1TallaCamiseta,
            est2NombreCompleto,
            est2Correo,
            est2Telefono,
            est2Edad,
            est2Sexo,
            est2TallaCamiseta,
            est3NombreCompleto,
            est3Correo,
            est3Telefono,
            est3Edad,
            est3Sexo,
            est3TallaCamiseta,
            requiereFactura,
            factNombre,
            factRfc,
            factCP,
            factUsoCFDI,
            factRegimenFiscal,
            comentarios,
            refBancaria,
            compPago,
            compPagoEst,
            claveProyRec,
            fechaRegistro,
            fechaPago,
            fechaPagoEst,
            "]"
        ); 

    };


    // Se ejecuta al cargarse el formulario
    useEffect(() => {
        document.title = "[Expociencias] CIBNOR";

        // Generar referencia bancaria
        // Dato a enviar como semilla para generar la referencia
        const randomVal = String(Date.now()) ;

        const dateNow = moment( Date.now() ).format('YYYY-MM-DDTHH:mm:ss');
        console.log(dateNow);
        // Se agrega al state
        setFormValues({
            ...formValues,
            refBancaria: getRefBancaria(PROY_RECURSOS + randomVal),
            fechaRegistro: dateNow,
        });

    }, []);
    

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sm">
                <CssBaseline />
                <Box sx={{ mt: 6, mb: 8, display: "flex", flexDirection: "column", alignItems: "center" }} >
                    <Avatar
                        sx={{ width: 270, height: 207 }}
                        src="https://eventos.cibnor.mx/registro/expociencias/img/logo_expociencias2022.png"
                        variant="square"
                    />
                    <Typography variant="h5">Registro en línea</Typography>

                    {/* Inicio del formulario */}
                    <Box
                        component="form"
                        noValidate
                        onSubmit={handleSubmit}
                        sx={{ mt: 3 }}
                        autoComplete="off"
                    >
                        {/* Asesor */}
                        <Accordion elevation={2} defaultExpanded={true}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Datos del asesor</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            autoComplete="given-name"
                                            autoFocus
                                            fullWidth
                                            id="asesorNombres"
                                            label="Nombres"
                                            name="asesorNombres"
                                            required
                                            size="small"
                                            value={asesorNombres}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            autoComplete="family-name"
                                            fullWidth
                                            id="asesorApellidos"
                                            label="Apellidos"
                                            name="asesorApellidos"
                                            required
                                            size="small"
                                            value={asesorApellidos}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            autoComplete="email"
                                            fullWidth
                                            id="asesorCorreo"
                                            label="Correo electrónico"
                                            name="asesorCorreo"
                                            required
                                            size="small"
                                            value={asesorCorreo}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Telefono
                                            parentCallback={handleInputChange}
                                            name={"asesorTelefono"}
                                            label={"Teléfono"}
                                            required={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TallaCamiseta
                                            parentCallback={handleInputChange}
                                            name={"asesorTallaCamiseta"}
                                            label={"Talla de camiseta"}
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>

                        {/* Institucion */}
                        <Accordion elevation={2} expanded={expandedPanel === 'panel2'} onChange={handleAccordionChange('panel2')}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Datos de la institución</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            autoComplete="organization"
                                            fullWidth
                                            id="instNombre"
                                            label="Nombre de la institución"
                                            name="instNombre"
                                            size="small"
                                            required
                                            value={instNombre}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <TextField
                                            autoComplete="street-address"
                                            fullWidth
                                            id="instDomicilio"
                                            label="Domicilio oficial"
                                            name="instDomicilio"
                                            size="small"
                                            required
                                            value={instDomicilio}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth size="small" required>
                                            <InputLabel id="select-municipio-label">
                                                Municipio
                                            </InputLabel>
                                            <Select
                                                id="instMunicipio"
                                                label="Municipio"
                                                labelId="select-municipio-label"
                                                name="instMunicipio"
                                                onChange={handleInputChange}
                                                value={instMunicipio}
                                            >
                                                <MenuItem value="Comondu">Comondú</MenuItem>
                                                <MenuItem value="La Paz">La Paz</MenuItem>
                                                <MenuItem value="Loreto">Loreto</MenuItem>
                                                <MenuItem value="Los Cabos">Los Cabos</MenuItem>
                                                <MenuItem value="Mulege">Mulegé</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>

                        {/* Proyecto */}
                        <Accordion elevation={2} expanded={expandedPanel === 'panel3'} onChange={handleAccordionChange('panel3')}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Datos del proyecto</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="proyTitulo"
                                            label="Nombre del proyecto u obra"
                                            name="proyTitulo"
                                            size="small"
                                            required
                                            value={proyTitulo}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth size="small" required>
                                            <InputLabel id="select-categoria-label">
                                                Categoría
                                            </InputLabel>
                                            <Select
                                                id="proyCategoria"
                                                label="Categoría"
                                                labelId="select-categoria-label"
                                                name="proyCategoria"
                                                onChange={handleInputChange}
                                                value={proyCategoria}
                                            >
                                                <MenuItem value="Pandillas científicas PETIT (Preescolar, 1° y 2° de Primaria)">
                                                Pandillas científicas PETIT (Preescolar, 1° y 2° de Primaria)
                                                </MenuItem>
                                                <MenuItem value="Pandillas Científicas KIDS (3° a 6° de Primaria)">
                                                Pandillas Científicas KIDS (3° a 6° de Primaria)
                                                </MenuItem>
                                                <MenuItem value="Pandillas Científicas Juvenil (Secundaria)">
                                                Pandillas Científicas Juvenil (Secundaria)
                                                </MenuItem>
                                                <MenuItem value="Medio-Superior (Preparatoria, bachillerato o equivalente)">
                                                Medio-Superior (Preparatoria, bachillerato o equivalente)
                                                </MenuItem>
                                                <MenuItem value="Superior (Universidad o equivalente)">
                                                Superior (Universidad o equivalente)
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth size="small" required>
                                            <InputLabel id="select-area-label">Área</InputLabel>
                                            <Select
                                                id="proyArea"
                                                label="Área"
                                                labelId="select-area-label"
                                                name="proyArea"
                                                onChange={handleInputChange}
                                                value={proyArea}
                                            >
                                                <MenuItem value="Agropecuarias y Alimentos">
                                                Agropecuarias y Alimentos
                                                </MenuItem>
                                                <MenuItem value="Ciencias Exactas y Naturales">
                                                Ciencias Exactas y Naturales
                                                </MenuItem>
                                                <MenuItem value="Biología">
                                                Biología
                                                </MenuItem>
                                                <MenuItem value="Medio Ambiente">
                                                Medio Ambiente
                                                </MenuItem>
                                                <MenuItem value="Ciencias de la Ingeniería">
                                                Ciencias de la Ingeniería
                                                </MenuItem>
                                                <MenuItem value="Medicina y Salud">
                                                Medicina y Salud
                                                </MenuItem>
                                                <MenuItem value="Ciencias de los Materiales">
                                                Ciencias de los Materiales
                                                </MenuItem>
                                                <MenuItem value="Mecatrónica">
                                                Mecatrónica
                                                </MenuItem>
                                                <MenuItem value="Computación y Software">
                                                Computación y Software
                                                </MenuItem>
                                                <MenuItem value="Sociales y Humanidades">
                                                Sociales y Humanidades
                                                </MenuItem>
                                                <MenuItem value="Divulgación de la Ciencia">
                                                Divulgación de la Ciencia
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextareaCustom
                                            parentCallback={handleInputChange}
                                            name="proyResumen"
                                            label="Resumen"
                                            required
                                            helperText="Máximo 250 palabras."
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>

                        {/* Estudiantes */}
                        <Grid container spacing={2} sx={{ pt: 2 }} >
                            <Grid item xs={12}>
                            <Paper elevation={2} >
                                <Card variant="outlined" >
                                    <CardContent>
                                        {/* Participacion */}
                                        <Grid item xs={12} sx={{ pb: 2 }}>
                                            <SelectCustom
                                                parentCallback={handleInputChange}
                                                name={"participacion"}
                                                label={"Tipo de participación"}
                                                variant={"standard"}
                                                options={[
                                                    {value:'individual', label:'Individual'},
                                                    {value:'equipo2', label:'Equipo de 2 estudiantes'},
                                                    {value:'equipo3', label:'Equipo de 3 estudiantes'},
                                                ]}
                                            />
                                        </Grid>
                                        {/* Estudiante uno */}
                                        <Slide direction="down" timeout={600} in={(participacion !== '')} >
                                        <Grid 
                                            container spacing={1} 
                                            sx={ (participacion === 'individual' || participacion === 'equipo2' || participacion === 'equipo3') ? { pt: 2, display:'flex' } : { pt: 2, display:'none' } }
                                        >
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    id="est1NombreCompleto"
                                                    label={`Nombre completo del ${(participacion === 'individual') ? '' : 'primer '}estudiante`}
                                                    name="est1NombreCompleto"
                                                    required
                                                    size="small"
                                                    value={est1NombreCompleto}
                                                    onChange={handleInputChange}
                                                />
                                            </Grid>
                                            <Grid item xs={8}>
                                                <TextField
                                                    fullWidth
                                                    id="est1Correo"
                                                    label="Correo electrónico"
                                                    name="est1Correo"
                                                    required
                                                    size="small"
                                                    value={est1Correo}
                                                    onChange={handleInputChange}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Telefono
                                                    parentCallback={handleInputChange}
                                                    name={"est1Telefono"}
                                                    label={"Teléfono"}
                                                    required={true}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Edad
                                                    parentCallback={handleInputChange}
                                                    name={"est1Edad"}
                                                    label={"Edad en años"}
                                                    required={true}
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Sexo
                                                    parentCallback={handleInputChange}
                                                    name={"est1Sexo"}
                                                    label={"Sexo"}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={5}>
                                                <TallaCamiseta
                                                    parentCallback={handleInputChange}
                                                    name={"est1TallaCamiseta"}
                                                    label={"Talla de camiseta"}
                                                />
                                            </Grid>
                                        </Grid>
                                        </Slide>
                                        {/* Estudiante dos */}
                                        <Slide direction="down" timeout={600} in={(participacion === 'equipo2' || participacion === 'equipo3')}>
                                        <Grid 
                                            container spacing={1} 
                                            sx={ (participacion === 'equipo2' || participacion === 'equipo3') ? { pt: 2, display:'flex' } : { pt: 2, display:'none' } }
                                        >
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    id="est2NombreCompleto"
                                                    label="Nombre completo del segundo estudiante"
                                                    name="est2NombreCompleto"
                                                    required
                                                    size="small"
                                                    value={est2NombreCompleto}
                                                    onChange={handleInputChange}
                                                />
                                            </Grid>
                                            <Grid item xs={8}>
                                                <TextField
                                                    fullWidth
                                                    id="est2Correo"
                                                    label="Correo electrónico"
                                                    name="est2Correo"
                                                    required
                                                    size="small"
                                                    value={est2Correo}
                                                    onChange={handleInputChange}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Telefono
                                                    parentCallback={handleInputChange}
                                                    name={"est2Telefono"}
                                                    label={"Teléfono"}
                                                    required={true}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Edad
                                                    parentCallback={handleInputChange}
                                                    name={"est2Edad"}
                                                    label={"Edad en años"}
                                                    required={true}
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Sexo
                                                    parentCallback={handleInputChange}
                                                    name={"est2Sexo"}
                                                    label={"Sexo"}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={5}>
                                                <TallaCamiseta
                                                    parentCallback={handleInputChange}
                                                    name={"est2TallaCamiseta"}
                                                    label={"Talla de camiseta"}
                                                />
                                            </Grid>
                                        </Grid>
                                        </Slide>
                                        {/* Estudiante tres */}
                                        <Slide direction="down" timeout={600} in={(participacion === 'equipo3')}>
                                        <Grid 
                                            container spacing={1} 
                                            sx={ (participacion === 'equipo3') ? { pt: 2, display:'flex' } : { pt: 2, display:'none' } }
                                        >
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    id="est3NombreCompleto"
                                                    label="Nombre completo del tercer estudiante"
                                                    name="est3NombreCompleto"
                                                    required
                                                    size="small"
                                                    value={est3NombreCompleto}
                                                    onChange={handleInputChange}
                                                />
                                            </Grid>
                                            <Grid item xs={8}>
                                                <TextField
                                                    fullWidth
                                                    id="est3Correo"
                                                    label="Correo electrónico"
                                                    name="est3Correo"
                                                    required
                                                    size="small"
                                                    value={est3Correo}
                                                    onChange={handleInputChange}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Telefono
                                                    parentCallback={handleInputChange}
                                                    name={"est3Telefono"}
                                                    label={"Teléfono"}
                                                    required={true}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Edad
                                                    parentCallback={handleInputChange}
                                                    name={"est3Edad"}
                                                    label={"Edad en años"}
                                                    required={true}
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Sexo
                                                    parentCallback={handleInputChange}
                                                    name={"est3Sexo"}
                                                    label={"Sexo"}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={5}>
                                                <TallaCamiseta
                                                    parentCallback={handleInputChange}
                                                    name={"est3TallaCamiseta"}
                                                    label={"Talla de camiseta"}
                                                />
                                            </Grid>
                                        </Grid>
                                        </Slide>

                                    </CardContent>
                                </Card>
                            </Paper>
                            </Grid>
                        </Grid>

                        {/* Facturación */}
                        <Grid container spacing={2} sx={{ pt: 2 }} >
                            <Grid item xs={12}>
                            <Paper elevation={2} >
                                <Card variant="outlined" >
                                <CardContent>
                                    {/* Requiere factura */}
                                    <Grid item xs={12} sx={{ pt: 1 }}>
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Switch 
                                                inputProps={{ 'aria-label': 'ant design' }} 
                                                id={'requiereFactura'}
                                                name={'requiereFactura'}
                                                onChange={switchHandler}
                                                checked={checked} 
                                            />
                                            <Typography>Requiere factura</Typography>
                                        </Stack>
                                    </Grid>

                                    <Slide direction="up" timeout={600} in={requiereFactura} >
                                        
                                        <Grid item xs={12} sx={ requiereFactura ? { pt: 2, display:'flex' } : { pt: 2, display:'none' } }>
                                            <DatosFactura parentCallback={handleInputChange} />
                                        </Grid>
                                        
                                    </Slide>

                                </CardContent>
                                </Card>
                            </Paper>
                            </Grid>
                            
                        </Grid>
                        
                        {/* Comentarios adicionales */}
                        <Grid container spacing={2} sx={{ pt: 2 }}>
                            <Grid item xs={12}>
                            <Paper elevation={2} >
                                <Card variant="outlined">
                                <CardContent>
                                    <TextareaCustom
                                        parentCallback={handleInputChange}
                                        name="comentarios"
                                        label="Comentarios adicionales"
                                    />
                                </CardContent>
                                </Card>
                            </Paper>
                            </Grid>
                        </Grid>

                        {/* Leyenda */}
                        <Grid container spacing={2} sx={{ pt: 2, pb: 3 }}>
                            <Grid item xs={12}>
                            <Paper elevation={2}>
                                <Card variant="outlined" sx={{ pt: 3, pb: 0 }}>
                                <CardContent>
                                    
                                    
                                    <Typography variant="body1" paragraph align="center" color="text.primary">
                                    Al presionar el botón [ ENVIAR ] aceptamos las 
                                    </Typography>
                                    
                                    <Typography variant="body1" paragraph align="center" color="text.primary">
                                    <a href="https://www.cibnor.gob.mx/eventos-cibnor/3180-expociencias-2022#participacion" target="_blank" rel="noreferrer" >
                                    <strong>CONDICIONES DE PARTICIPACIÓN DESCRITAS EN ESTE ENLACE</strong>
                                    </a>
                                    </Typography>
                                </CardContent>
                                </Card>
                            </Paper>
                            </Grid>
                        </Grid>

                        {/* Boton */}
                        <Paper elevation={2}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="outlined"
                            endIcon={<SendIcon />}
                        >
                            Enviar
                        </Button>
                        </Paper>
                    </Box>
                    
                    {/* Footer */}
                    <Grid container spacing={2} sx={{ pt: 8, pb: 2 }}>
                        <Grid item xs={12}>
                            <Divider />
                            <Typography gutterBottom sx={{ fontSize:'9px', textDecorationLine: 'none' }} paragraph align="right" color="text.secondary">
                                <strong>Centro de investigaciones Biológicas del Noroeste S.C.</strong><br />
                                Instituto Politécnico Nacional 195, Playa Palo de Santa Rita Sur.<br />
                                La Paz, B.C.S., México; C.P. 23096, Tel:(52) (612) 123-8484<br />
                                <a href="http://www.cibnor.gob.mx/component/content/article/472" target="_blank" rel="noreferrer" >Política de privacidad</a>
                            </Typography >
                        </Grid>
                    </Grid>
                    
                </Box>
                {/* Dialogo de confirmacion */}
                <Dialog
                    open={openConfirmDialog}
                    onClose={handleCloseConfirmDialog}
                    disableEscapeKeyDown={true}
                >
                    <DialogTitle id="alert-dialog-title">
                        {"¿Desea continuar?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Por favor, confirme la información ingresada antes de continuar.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseConfirmDialog}>No</Button>
                        <Button onClick={handleConfirmDialogButtonYes} autoFocus>Si</Button>
                    </DialogActions>
                </Dialog>
                {/* Dialogo de espera porque se esta enviando la informacion */}
                <Dialog 
                    open={sendingForm}
                    onClose={handleCloseWaitingDialog}
                    disableEscapeKeyDown={true}
                    >
                    <DialogTitle id="alert-dialog-title" >
                        {"Por favor, espere..."}
                    </DialogTitle>
                    <DialogContent sx={{
                                    margin: 2,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
                {/* Dialogo de registro cerrado */}
                <CustomDialog 
                    show={false} 
                    title={'Gracias por su interes...'} 
                    content={'Este evento actualmente se encuentra cerrado.'} 
                />

                
            </Container>
        </ThemeProvider>
    );
};
